import { Button } from "antd";
import Upload from "antd/es/upload";
import { UploadOutlined } from '@ant-design/icons';
import { API_BASE_URL } from "../config";
import APIClient from "../api/api";

const UploadExternalDomains = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <Upload name="file" action={API_BASE_URL + "/v1/domainLeads/add-external"} headers={APIClient.getAuthHeaders()}>
                <Button icon={<UploadOutlined />}>Upload External Domains</Button>
            </Upload>
        </div>
    );
};
export default UploadExternalDomains;
